import axios from "axios";
import Links from "../constants/Links";

const BASE = "clearance";
const Clearance = {
    admin: {
        /**
         * Create clearance
         * @param {object} param0 
         * @returns 
         */
        create: async ({session, name, description}) => {
            return axios.post(`${BASE}/${Links.clearance.create}`, {
                session, description, name
            })
        },
    
        /**
         * Update created clearance
         * @param {string} id selected clearance id
         * @param {object} param1 clearance attributes
         * @returns 
         */
        update: async (id, {session, name, description}) => {
            return axios.put(`${BASE}/${Links.clearance.update}/${id}`, {
                session, 
                description, 
                name
            })
        },
    
        /**
         * Delete clearance 
         * @param {string} id selected clearance id
         * @returns 
         */
        delete: async (id) => {
            return axios.delete(`${BASE}/${Links.clearance.delete}/${id}`)
        },

        unpaginated: async () => {
            return axios.get(`${BASE}/${Links.clearance.unpaginated}`)
        },
    
        /**
         * Fetch all clearance
         * @param {string} page selected page number
         * @param {string} size selected page size
         * @returns 
         */
        all: async (page, size) => {
            return axios.get(`${BASE}/${Links.clearance.all}`, {
                params: {
                    page, size
                }
            })
        },

        /**
         * Fetch clearance associated to a session
         * @param {string} sessionId 
         * @returns 
         */
        session: async (sessionId) => {
            return axios.get(`${BASE}/${Links.clearance.session}/${sessionId}`)
        },


        /**
         * Fetch all clearance officials
         * 
         * @returns 
         */
        officials: async () => {
            return axios.get(`${BASE}/${Links.clearance.officials}`)
        },
    },

    requirements: {
        /**
         * Create requirements
         * @param {object} param0 
         * @returns 
         */
        create: async({
            code, 
            name, 
            description, 
            stageId, 
            requirementType, 
            validationTypes, 
            mandatory, 
            paymentPlatform, 
            amount, 
            serviceId 
        }) => {
            return axios.post(`${Links.clearance.clearanceRequirement.BASE}/create`, {
                code, 
                name, 
                description, 
                stageId, 
                requirementType, 
                validationTypes, 
                mandatory, 
                paymentPlatform, 
                amount, 
                serviceId
            })
        },

        /**
         * Update an office
         * @param {string} id 
         * @param {object} param1 
         * @returns 
         */
        update: async(id, {code, name, description, stageId, requirementType, validationTypes, mandatory, paymentPlatform, amount, serviceId }) => {
            return axios.put(`${Links.clearance.clearanceRequirement.BASE}/update/${id}`, {
                code, name, description, stageId, requirementType, validationTypes, mandatory, paymentPlatform, amount, serviceId
            })
        },

        /**
         * Fetch requirements based on selected stage
         * @param {string} stageId 
         * @returns 
         */
        all: async (stageId) => {
            return axios.get(`${Links.clearance.clearanceRequirement.BASE}/stage/${stageId}`)
        },

        /**
         * Current this endpoint is not in use in this system, hence its @deprecated 
         * @param {string} stageId selected stageId
         * @returns 
         */
        forStage: async (stageId) => {
            return axios.get(`${Links.clearance.clearanceRequirement.BASE}/${Links.clearance.clearanceRequirement.stage}/${stageId}`)
        },

        /**
         * Delete requirement
         * @param {string} requirementId selected requirement
         * @returns 
         */
        delete: async (requirementId) => {
            return axios.delete(`${Links.clearance.clearanceRequirement.BASE}/delete/${requirementId}`)
        },

        /**
         * Make a requirement compulsory
         * @param {string} requirementId selected requirement
         * @returns 
         */
        makeMandatory: async (requirementId) => {
            return axios.put(`${Links.clearance.clearanceRequirement.BASE}/make-mandatory/${requirementId}`)
        },

        /**
         * Fetch file types
         * @returns 
         */
        types: async () => {
            return axios.get(`${Links.clearance.clearanceRequirement.BASE}/types`)
        },

        /**
         * Fetch validationt types
         * @returns 
         */
        validationTypes: async () => {
            return axios.get(`${Links.clearance.clearanceRequirement.BASE}/validation-types`)
        },
    },

    stages: {
        /**
         * Previous and Next stage IDs are optional
         * @param name
         * @param previousStageId
         * @param nextStageId
         * @param clearanceId
         * @param enableManualApproval
         * @param enableResultApproval
         * @returns {Promise<any>}
         */
        create: async ({
            name, 
            previousStageId, 
            nextStageId, 
            clearanceId, 
            enableManualApproval, 
            enableResultApproval,
            enablePaymentProcessing,
        }) => {
            return axios.post(`${Links.clearance.stages.BASE}`, {
                name, 
                previousStageId, 
                nextStageId, 
                clearanceId, 
                enableManualApproval, 
                enableResultApproval,
                enablePaymentProcessing,
            })
        },

        /**
         * Previous and Next stage IDs are optional
         * @param id
         * @param name
         * @param previousStageId
         * @param nextStageId
         * @param clearanceId
         * @param enableManualApproval
         * @param enableResultApproval
         * @param enablePaymentProcessing
         * @returns {Promise<any>}
         */
        update: async (id, {name, previousStageId, nextStageId, clearanceId, enableManualApproval, enableResultApproval, enablePaymentProcessing}) => {
            return axios.put(`${Links.clearance.stages.BASE}/${id}`, {
                name, 
                previousStageId, 
                nextStageId, 
                clearanceId, 
                enableManualApproval, 
                enableResultApproval,
                enablePaymentProcessing
            })
        },

        delete: async (id) => {
            return axios.delete(`${Links.clearance.stages.BASE}/${id}`)
        },

        /**
         * 
         * @param {*} page 
         * @param {*} size 
         * @returns 
         */
        all: async (clearance, page, size) => {
            return axios.get(`${Links.clearance.stages.BASE}`, {
                params: {
                    clearance,
                    page, 
                    size
                }
            })
        },

        /**
         * Gets previous stage before the stage having {stageId}
         * @param stageId
         * @returns {Promise<any>}
         */
        previous: async (stageId) => {
            return axios.get(`${Links.clearance.stages.BASE}/${Links.clearance.stages.previous}/${stageId}`)
        },

        /**
         * Gets previous stage after the stage having {stageId}
         * @param stageId
         * @returns {Promise<any>}
         */
        next: async (stageId) => {
            return axios.get(`${Links.clearance.stages.BASE}/${Links.clearance.stages.next}/${stageId}`)
        },

        /**
         * Gets all stages for a clearance
         * @param clearanceId
         * @param pageNumber
         * @param pageSize
         * @returns {Promise<any>}
         */
        allStages: async (page, size) => {
            return axios.get(`${Links.clearance.stages.BASE}/${Links.clearance.stages.all}`, {
                params: {
                    page,
                    size,
                }
            })
        },

        upaginated: async (clearance) => {
            return axios.get(`${Links.clearance.stages.BASE}/${Links.clearance.stages.unpaginated}`, {
                params: {
                    clearance
                }
            })
        },

        forUser: async (clearanceId, userId) => {
            return axios.get(`${Links.clearance.stages.BASE}/${Links.clearance.stages.forUser}`, {
                params: {
                    clearance: clearanceId,
                    user: userId
                }
            })
        },

        students: async (stage, status, page, size) => {
            return axios.get(`${Links.clearance.stages.BASE}/${Links.clearance.stages.students}`, {
                params: {
                    page,
                    size,
                    status,
                    stage
                }
            })
        },

        /**
         * Assign stage to an office
         * @param {string} officeId 
         * @param {string} stageId 
         * @returns 
        */
        assignOfficeToStage: async (officeId, stageId) => {
                    return axios.put(`${Links.clearance.stages.BASE}/assign-office/${officeId}/${stageId}`, {
                        officeId,
                        stageId
                    })
                },
                
                /**
                 * Un-Assign stage to an office
                 * @param {string} officeId 
                 * @param {string} stageId 
                 * @returns 
                 */
                unassignOfficeToStage: async (officeId, stageId) => {
                    return axios.put(`${Links.clearance.stages.BASE}/unassign-office`, {
                        officeId,
                        stageId
                    })
                }
    }, 

    office: {
        /**
         * Create an office name
         * @param {string} name 
         * @returns 
         */
        create: async (name) => {
            return axios.post(`${Links.clearance.office.BASE}`, {
                name
            });
        }, 

        /**
         * Update an office
         * @param {string} id selected office
         * @param {string} name selected office name
         * @returns 
         */
        update: async (id, name) => {
            return axios.put(`${Links.clearance.office.BASE}/${id}`, {
                name
            })
        }, 

        /**
         * Fetch all offices
         * @param {string} page selected page no
         * @param {string} size selected page size
         * @returns 
         */
        all: async (page, size) => {
            return axios.get(`${Links.clearance.office.BASE}`, {
                params: {
                    page, 
                    size,
                }
            })
        },


        /**
         * Delete an office
         * @param {string} id 
         * @returns 
         */
        delete: async (id) => {
            return axios.delete(`${Links.clearance.office.BASE}/${id}`)
        },

        /**
         * user.id, officeId. isHead
         * Get the office Head User for a specific office
         * @param {string} officeId 
         * @returns 
         */
        getOfficeHeads:async (officeId) => {
            return axios.get(`${Links.clearance.office.BASE}/${Links.clearance.office.head}/${officeId}`)
        },
        
        /**
         * assign User to a specified Office
         * @param {string} office 
         * @param {*} user 
         * @returns 
         */
        assignOfficeUser: async (office, user, head = false) => {
            return axios.put(`${Links.clearance.office.BASE}/assign-user`, {
                office, 
                user,
                head,
            })
        },

        /**
         * remove User from a specified office
         * @param {string} office
         * @param {string} user
         * @returns 
         */
        removeOfficeUser: async (office, user) => {
            return axios.put(`${Links.clearance.office.BASE}/remove-user`, {
                office, 
                user
            })
        },

        /**
         * get all users for a specified office
         * @param {string} officeId 
         * @returns 
         */
        allOfficeUsers: async (officeId) => {
            return axios.get(`${Links.clearance.office.BASE}/users?office=${officeId}`)
        }, 
    },

    postStage: {
        /**
         * Upload document
         * @param {string} file selected file
         * @param {string} documentName selected document
         * @param {string} stage selected stage
         * @returns 
         */
        postDoc: async (file, documentName, stage) => {
            const fData = new FormData(); 
            fData.append("file", file); 
            fData.append("documentName", documentName); 
            fData.append("stage", stage); 

            return axios.post(`${Links.clearance.stages.BASE}/poststage-document`, fData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
        }, 

        /**
         * Download student document file
         * @param {string} stageId selected stage 
         * @param {string} documentId selected document 
         * @returns 
         */
        downloadStudentStageDoc: async (student, document) => {
            return axios.get(`${Links.clearance.stages.BASE}/download`, {
                params: {
                    student, 
                    document
                },

                responseType: 'blob'
            })
        }, 

        /**
         * Delete student stage document
         * @param {string} documentId selected document
         * @returns 
         */
        deletePostStageDoc: async (documentId) => {
            return axios.delete(`${Links.clearance.stages.BASE}/poststage-document/delete/${documentId}`)
        }, 
    },

    dept: {
        /**
         * Upload the excel document containing the list of students userId, the params are the file, departmentId and 
         * @param {*} file 
         * @param {*} department
         * @param {*} clearance 
         * @returns 
         */
        uploadStudents: async (file, department, clearance) => {
            const data = new FormData();
            data.append("file", file)
            data.append("department", department)
            data.append("clearance", clearance)
            return axios.post(`${Links.clearance.department.base}/${Links.clearance.department.upload}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
        }, 

        /**
         * @param {number} department to submit
         * @parama {number} the clearance to submit to
         */
        submit: async (department, clearance) => {
            return axios.post(`${Links.clearance.department.base}/${Links.clearance.department.submit}`, {
                department, clearance
            })
        },

        /**
         * Submits the uploaded list of students
         * @param {*} departmentClearanceId 
         * @returns 
         */
        getSubmittedClearance: async (departmentClearanceId) => {
            return axios.get(`${Links.clearance.department.base}/${Links.clearance.department.submit}/${departmentClearanceId}`)
        },

        /**
         * fetch all uploaded students for the specified department clearance
         * @param {*} department 
         * @param {*} clearance 
         * @param {*} page 
         * @param {*} size 
         * @returns 
         */
        deptStudent: async (department, clearance, page, size) => {
            return axios.get(`${Links.clearance.department.base}/${Links.clearance.department.students}`, {
                params: {
                    page, 
                    size,
                    department,
                    clearance
                }
            })
        }, 

        /**
         * fetch all department clearance students that has been submitted
         * @param {*} department 
         * @param {*} clearance 
         * @returns 
         */
        getSubmittedStudents: async (department, clearance, page, size) => {
            return axios.get(`${Links.clearance.department.base}/submitted-students?department=${department}&clearance=${clearance}`, {
                page, 
                size,
            })
        },

        /**
         * Fetch all department clearance students yet to be submitted
         * @param {*} department 
         * @param {*} clearance 
         * @param {*} page 
         * @param {*} size 
         * @returns 
         */
        getUnsubmittedStudents: async (department, clearance, page, size) => {
            return axios.get(`${Links.clearance.department.base}?department=${department}&clearance=${clearance}`, {
                page, 
                size
            })
        },
    },

    student: {
        /**
         * Fetch checked clearance students
         * @param {string} stageId 
         * @returns 
         */
        checkedStudent: async (stageId) => {
            return axios.get(`${Links.clearance.stages.BASE}/students/requirement-checked/${stageId}`)
        }, 

        /**
         * Fetch unchecked clearance students
         * @param {string} stageId 
         * @returns 
         */
        uncheckedStudent: async (stageId) => {
            return axios.get(`${Links.clearance.stages.BASE}/students/requirement-unchecked/${stageId}`)
        }, 

        /**
         * Approve student clearance if deemed okay 
         * @param {string} stageStudentId 
         * @param {boolean} reason state the reason
         * @param {boolean} isApproved 
         * @returns 
         */
        approveStudent: async (stageStudentId, reason, isApproved) => {
            return axios.post(`${Links.clearance.stages.BASE}/student/approve-reject`, {
                stageStudentId,
                isApproved,
                reason,
            })
        }, 

        /**
         * Fetch all stage document associated to specific stage
         * @param {string} stageId selected stage documents 
         * @returns 
         */
        allStageDocuments: async (stageId) => {
            return axios.get(`${Links.clearance.stages.BASE}/all-documents/${stageId}`)
        }, 

        /**
         * 
         * @param {string} stageId 
         * @returns 
         */
        processStageRequirements: async (stageId) => {
            return axios.put(`${Links.clearance.stages.BASE}/process-requirements`, {
                stageId
            })
        },

        /**
         * Fetch eligible student with his/her matric number
         * @param {string} studentId selected student matric no
         * @returns 
         */
        findForStudent: async (studentId) => {
            return axios.get(Links.clearance.student.find, {
                params: {
                    student: studentId, 
                   // clearanceId
                }
            })
        },

        initializeTransaction: async (studentId, requirementId) => {
            return axios.post(Links.clearance.student.initializeTransaction, {
                studentId, 
                requirementId
            })
        },

        downloadUploadedDocument: async (responseId) => {
            return axios.get(Links.clearance.student.downloadUploadedDocument, {
                params: {
                    response:responseId
                }, 

                responseType: 'blob'
            })
        },

        /**
         * Submitted requirement from the student
         * @param {string} file selected file type
         * @param {string} text selected text
         * @param {string} requirement selected requirement type
         * @param {string} studentId selected student with matric number
         * @returns 
         */
        submitRequirement: async (file, text, requirement, studentId) => {
            const data = new FormData();
            data.append("file", file); 
            data.append("text", text); 
            data.append("requirement", requirement); 
            data.append("studentId", studentId); 

            return axios.post(`${Links.clearance.student.BASE}/submit`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
        },

        /**
         * This endpoint is deprecated and does not function as expected
         * 
         * @deprecated
         * @param {*} studentId 
         * @returns 
         */
        submittedResponse: async (studentId) => {
            return axios.get(`${Links.clearance.student.BASE}/reponses`, {
                params: {
                    studentId
                }
            })
        },

        /**
         * Fetch all requirements data for a student
         * @param {string} stage 
         * @param {string} student 
         * @returns 
         */
        requirementData: async (stage, student) => {
            return axios.get(Links.clearance.student.clearanceData, {
                params: {
                    stage, 
                    student,
                }
            })
        }
    }
}

export default Clearance
